import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import anim_line from "../../img/winter.png"
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import LoadingButton from "../../Loading/LoadingButton";
import { useSelector } from "react-redux";

import Snackbar from "../../../Snackbar";
import { createCourseByAdminV2 } from "../../../store/actions/CreateCourse/createCourseByAdmin";

import AppearanceToggleCard from "../../UI/AppearanceToggleCard";
import Toggle from "../../UI/Toggle";
import AppMenuCardBlueBG from "../AppCards/AppMenuCardBlueBG";
import AppMenuCardBlueBGTwo from "../AppCards/AppMenuCardBlueBGTwo";
const SettingsProduct = ({setActiveCardOverview,baseUrl})=>{
  const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();

   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
  const [goNextPopUp, setGoNextPopUp] =useState(false);
 
 const showSnackbar = () => {
   setSnackbarVisible(true);
 };

 const hideSnackbar = () => {
   setSnackbarVisible(false);
 };
 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
  {
    
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
  
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);

const postIdCourse = useSelector((state)=>state?.course?.course?.postId);

const courseData = useSelector((state)=>state?.course?.course);
const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const appId = useSelector((state)=>state?.app?.app?.ID);
const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);

 const [loader , setLoader] =useState();
 const [seofriendlyURL, setSeofriendlyURL] = useState(courseData?.seofriendlyURL?courseData?.seofriendlyURL:"");
 const [seoPageTitle, setSeoPageTitle] = useState(courseData?.seoPageTitle?courseData?.seoPageTitle:"");
 
 const [productID, setProductID] = useState(courseData?.ID?courseData?.ID:"");
 const [editType, setEditType] = useState(courseData?.ID?"seo":"");

 const [enableQnA, setEnableQnA] = useState(courseData?.enableQnA?JSON.parse(courseData?.enableQnA):false);
 const [enableComments, setEnableComments] = useState(courseData?.enableComments?JSON.parse(courseData?.enableComments):false);
 const [enableNotes, setEnableNotes] = useState(courseData?.enableNotes?JSON.parse(courseData?.enableNotes):false);
 const [enableReviews, setEnableReviews] = useState(courseData?.enableReviews?JSON.parse(courseData?.enableReviews):false);
 const [enableRetake, setEnableRetake] = useState(courseData?.enableRetake?JSON.parse(courseData?.enableRetake):false);
 const [enablePublicCourse, setEnablePublicCourse] = useState(courseData?.enablePublicCourse?JSON.parse(courseData?.enablePublicCourse):false);
 const [enableCertificates, setEnableCertificates] = useState(courseData?.enableCertificates?JSON.parse(courseData?.enableCertificates):false);
 const [enableWaitList, setEnableWaitList] = useState(courseData?.enableWaitList?JSON.parse(courseData?.enableWaitList):false);
 const [enablePresale, setEnablePresale] = useState(courseData?.enablePresale?JSON.parse(courseData?.enablePresale):false);
  let TypeTitle= courseData?.ID?courseData?.type=='course'?"Course":
  courseData?.type=='batch'?"Batch":
  courseData?.type=="testSeries"?"Test Series":
  courseData?.type=="homeTutor"?"Home Tutor Offering":
  courseData?.type=="bundle"?"Bundle":
courseData?.type=="digitalProduct"?"Digital Product":"Course":"Course";
 const [animate, setAnimate] = useState(false);

 useEffect(() => {
   // Trigger the animation after a delay (e.g., 500ms)
   const timer = setTimeout(() => {
    setAnimate(true);  
  }, 100);

   return () => clearTimeout(timer); // Cleanup on unmount
 }, []);
useEffect(()=>{
  setActiveCardOverview(true);
  
  // setCourseTitleData();
},[])

    
   

  const handleCreateProduct=(editVal,state)=>{
  let sendObject;
  if(editVal=="enableQnA"){
    setEnableQnA(state);
    setLoader({...loader,statusQna:true,status:true});
    sendObject ={enableQnA:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editVal=="enableComments"){
    setEnableComments(state);
    setLoader({...loader,statusComments:true,status:true});
    sendObject ={enableComments:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }if(editVal=="enableNotes"){
    setEnableNotes(state);
    setLoader({...loader,statusNotes:true,status:true});
   
    sendObject ={enableNotes:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editVal=="enableReviews"){
    setEnableReviews(state);
    setLoader({...loader,statusReviews:true,status:true});
   
    sendObject ={enableReviews:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }if(editVal=="enableRetake"){
    setEnableRetake(state);
    setLoader({...loader,statusRetake:true,status:true});
   
    sendObject ={enableRetake:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }if(editVal=="enablePublicCourse"){
    setEnablePublicCourse(state);
    setLoader({...loader,statusPublicCourse:true,status:true});
   
    sendObject ={enablePublicCourse:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }if(editVal=="enableCertificates"){
    setEnableCertificates(state);
    setLoader({...loader,statusCertificates:true,status:true});
   
    sendObject ={enableCertificates:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }if(editVal=="enableWaitList"){
    setEnableWaitList(state);
    setLoader({...loader,statusWaitList:true,status:true});
   
    sendObject ={enableWaitList:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }if(editVal=="enablePresale"){
    setEnablePresale(state);
    setLoader({...loader,statusPresale:true,status:true});
   
    sendObject ={enablePresale:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
  
  
    const apiData = dispatch(createCourseByAdminV2(sendObject));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){
        if(response?.course){
          
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
    if(editVal=="enableQnA"){
        setEnableQnA(JSON.parse(response?.course?.enableQnA));
        setLoader({...loader,statusQna:false});
    }
    if(editVal=="enableComments"){
        setEnableComments(JSON.parse(response?.course?.enableComments));
        setLoader({...loader,statusComments:false});
    }
    if(editVal=="enableNotes"){
        setEnableNotes(JSON.parse(response?.course?.enableNotes));
        setLoader({...loader,statusNotes:false});
    }
    if(editVal=="enableReviews"){
        setEnableReviews(JSON.parse(response?.course?.enableReviews));
        setLoader({...loader,statusReviews:false});
    }
    if(editVal=="enableRetake"){
        setEnableRetake(JSON.parse(response?.course?.enableRetake));
        setLoader({...loader,statusRetake:false});
    }
    if(editVal=="enablePublicCourse"){
        setEnablePublicCourse(JSON.parse(response?.course?.enablePublicCourse));
        setLoader({...loader,statusPublicCourse:false});
    }
    if(editVal=="enableCertificates"){
        setEnableCertificates(JSON.parse(response?.course?.enableCertificates));
        setLoader({...loader,statusCertificates:false});
    }
    if(editVal=="enableWaitList"){
        setEnableWaitList(JSON.parse(response?.course?.enableWaitList));
        setLoader({...loader,statusWaitList:false});
    }
    if(editVal=="enablePresale"){
        setEnablePresale(JSON.parse(response?.course?.enablePresale));
        setLoader({...loader,statusPresale:false});
    }
    
    setProductID(response?.course?.postId);
   
   setGoNextPopUp(true);
  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }
    
    return <>
    
{<>
  {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
<div  className="ikcraft_login-signup-card-outerj">

    <div  className="contentPageScroller " style={{background:"#fff",borderRadius:"25px"}}>
    <div className="gridFiftyFixed"style={{
       
    }}><div style={{  transform: animate ? 'scale(1)' : 'scale(.91)',
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',}}>
 <AppMenuCardBlueBG  activeCard={""} icon={5} title ="Settings " onClickPopup={
          ()=>{ history.push(`${baseUrl}/settings`) 
          }}  /></div>
<div><AppMenuCardBlueBGTwo activeCard={""} icon={1} title ="Appearance " onClickPopup={
        ()=>{ history.push(`${baseUrl}/appearance`)
        }}  /></div> 
        
 
 </div>
    <h1 style={{"textAlign":"center", transform: animate ? 'scale(1)' : 'scale(.91)',
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',
       
      }}> Settings For <span className="coloredTextV1" > Your {TypeTitle}.</span> </h1>
      
  <div  className=" gridForWhatsNextAfterYT5 ">
   
      
 <div  className="ikcraft_login-input-card"style={{
        
      }}><div className="gridForFiftyFixed"style={{
        transform: animate ? 'scale(1)' : 'scale(.1)',
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',
      }}><div><h4>{loader?.statusQna?"loading...":"Enable QnA Section "} </h4></div>
      <Toggle state={enableQnA} toggleState={(state)=>{handleCreateProduct("enableQnA",state)}} />
         </div><div className="gridForFiftyFixed"style={{
        transform: animate ? 'scale(1)' : 'scale(.1)',
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 2s ease',
      }}><div><h4>{loader?.statusComments?"loading...":"Enable Comments Section "} </h4></div>
      <Toggle state={enableComments} toggleState={(state)=>{handleCreateProduct("enableComments",state)}} />
         </div>
         <div className="gridForFiftyFixed"style={{
        transform: animate ? 'scale(1)' : 'scale(.1)',
        opacity: animate ? 1 : 0,
        transition: 'transform 2.5s ease, opacity 2.5s ease',
      }}><div><h4>{loader?.statusNotes?"loading...":"Enable Students Notes Section "} </h4></div>
      <Toggle state={enableNotes} toggleState={(state)=>{handleCreateProduct("enableNotes",state)}} />
         </div>
         <div className="gridForFiftyFixed"style={{
        transform: animate ? 'scale(1)' : 'scale(.1)',
        opacity: animate ? 1 : 0,
        transition: 'transform 3s ease, opacity 3s ease',
      }}><div><h4>{loader?.statusReviews?"loading...":"Enable Students Reviews  "} </h4></div>
      <Toggle state={enableReviews} toggleState={(state)=>{handleCreateProduct("enableReviews",state)}} />
         </div>
        
         



         </div>
 <div  className="ikcraft_login-input-card"style={{
          }}> 
     <div className="gridForFiftyFixed" style={{
        transform: animate ? 'translateY(0)' : 'translateY(150px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 2s ease',
      }}><div><h4>{loader?.statusPublicCourse?"loading...":"Enable Public Course (no enrolment required) "} </h4></div>
      <Toggle state={enablePublicCourse} toggleState={(state)=>{handleCreateProduct("enablePublicCourse",state)}} />
         </div>
         <div className="gridForFiftyFixed"style={{
        transform: animate ? 'translateY(0)' : 'translateY(150px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 2.5s ease, opacity 2.5s ease',
      }}><div><h4>{loader?.statusCertificates?"loading...":"Enable Certificates "} </h4></div>
      <Toggle state={enableCertificates} toggleState={(state)=>{handleCreateProduct("enableCertificates",state)}} />
         </div>
        
         <div className="gridForFiftyFixed"style={{
        transform: animate ? 'translateY(0)' : 'translateY(150px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 3.5s ease, opacity 3.5s ease',
      }}><div><h4>{loader?.statusPresale?"loading...":"Enable Presale (for future launch)"} </h4></div>
      <Toggle state={enablePresale} toggleState={(state)=>{handleCreateProduct("enablePresale",state)}} />
         </div> <div className="gridForFiftyFixed"style={{
        transform: animate ? 'translateY(0)' : 'translateY(150px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 4s ease, opacity 4s ease',
      }}><div><h4>{loader?.statusRetake?"loading...":"Enable Startover & Retake  "} </h4></div>
      <Toggle state={enableRetake} toggleState={(state)=>{handleCreateProduct("enableRetake",state)}} />
         </div>
</div></div>

<div style={{height:"70px"}}></div>
   <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{history.push(`${baseUrl}/appearance`)}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Back </button>

 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{history.push(`${baseUrl}/content`)}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":productID?"Go Next":"Go Next"} </button>
     
  </div>
  
    <div  className="ikcraft_login-input-card">
   
      
  </div>

  <div> 
    
    
    
    
  </div>
 </div>
    
 <div></div>
 

  </div>
</>}
    </>

}

export default SettingsProduct;

